module.exports = __webpack_public_path__ + "img/levels-25_small.ff9cbd07.png";